/***
*
*   attachKarbonTfnCheck
*   Checks each TFN field on a Karbon onboarding form before the client can
*   leave the page or complete the form.
*
*   The rule (which fields hold a TFN) and the verdict (which values fail) are
*   the Karbon submit gate's, through tfnFieldError. The field names come from
*   the schema, not the question: survey-core drops the unregistered `tfn`
*   property when it builds dynamic-panel rows, and every Karbon TFN is in one.
*
*   Adds the handler only when enabled is exactly true. While the flag is
*   missing or still loading, nothing is attached and the server stays the
*   only check. The handler writes options.error only for a failing value:
*   survey-core shares one options object across handlers, so writing null
*   would clear an error that an earlier handler set.
*
*   Known limit: a TFN asked in a matrix column is not checked here.
*   survey-core validates a matrix cell through onMatrixCellValidate, not
*   onValidateQuestion, and the matrix's own value is rows, which the verdict
*   skips. The Karbon template asks no TFN in a matrix; on a form that does, the
*   server gate stays the only check.
*
*   model  - the survey-core Model
*   enabled - formAPI.data.karbon_onboarding
*   schema  - the form schema the model was built from
*   returns - a function that removes the handler
*
**********/

const {
  tfnFieldError,
  tfnQuestionNamesFromSchema,
} = require("./australian-identifiers");

export function attachKarbonTfnCheck(model, { enabled, schema } = {}) {
  if (enabled !== true) return () => {};

  const fieldNames = tfnQuestionNamesFromSchema(schema);
  const checkTfn = (sender, options) => {
    const error = tfnFieldError(options.name, options.value, fieldNames);
    if (error) options.error = error;
  };

  model.onValidateQuestion.add(checkTfn);
  return () => model.onValidateQuestion.remove(checkTfn);
}
